<template>
    <a-list
        class="thread-list"
        :loading="loading"
        item-layout="horizontal"
        :data-source="data"
    >
        <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
                <span slot="title" class="thread-title">
                    <a :href="`/bbs/thread/?bid=${item.bid}&tid=${item.tid}&p=1`" target="_blank">{{ item.title }}</a>
                    <a-icon v-if="item.top > 0" type="pushpin"/>
                    <a-icon v-if="item.extr > 0" type="star"/>
                </span>
                <a-icon slot="avatar" type="unordered-list" style="color: orange;"/>
                <span slot="description">
                    <user-link :name="item.author" :id="item.authorid"/> 发表于{{ item.postdate }} |
                    <span v-if="item.replyer">
                        <user-link :name="item.replyer" :id="item.replyerid"/> 最后回复于{{ formatDate(item.timestamp) }}
                    </span>
                    <span v-else>
                        还没有回复
                    </span>
                </span>
            </a-list-item-meta>
            <div>
                <a-icon type="message"/>
                <span class="reply-count">{{ item.reply }}</span>
            </div>
        </a-list-item>
        <a-pagination :current="Number($route.params.page)" :total="total" 
            :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
        />
    </a-list>
</template>

<script>
import UserLink from '../../components/UserLink.vue';
import axios from '../../plugins/axios';
import { scrollToElm } from '../../utils/utils';

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.name, to.params.page);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.name, to.params.page);
        next();
    },
    data: () => ({
        data: [],
        total: 0,
        loading: false,
    }),
    methods: {
        async load(bid, page) {
            this.loading = true;
            scrollToElm(document.getElementById("app"));
            const { data } = await axios.get(`/backend/bbs/list.php`, {
                params: {
                    bid, page
                }
            });
            this.loading = false;
            this.data = data.list;
            this.total = data.total;
        },
        turnPage(page) {
            this.$router.push({ name: this.$route.name, params: { page } });
        },
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        }
    },
    components: {
        UserLink
    },
}
</script>

<style lang="less" scoped>
.ant-list-item-meta {
    text-align: left;
}
.ant-list-item-meta-title {
    font-size: 18px;
    line-height: 24px;
}
.reply-count {
    width: 30px;
    display: inline-block;
}
.thread-title {
    a {
        color: rgba(0, 0, 0, 0.65);
    }
    .anticon {
        margin: 0px 5px;
    }
}
</style>